module.exports = __webpack_public_path__ + "img/fa-regular-400.89f9806b.svg";